document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('[id^="shopify-section-"]');

  sections.forEach((sectionEl) => {
    const sectionId = sectionEl.id.replace('shopify-section-', '');
    const carouselEl = sectionEl.querySelector(`[data-carousel-id="${sectionId}"]`);
    const settingsEl = sectionEl.querySelector('[data-carousel-settings]');

    if (!carouselEl || !settingsEl) return;

    const itemsCount = parseInt(settingsEl.dataset.itemsCount) || 4;
    const $carousel = $(carouselEl);

    // Prevent duplicate initialization
    if ($carousel.hasClass('owl-loaded')) return;

    const isWithSide = sectionEl.querySelector('.product-carousel-wrapper-side') !== null;

    const responsiveSettings = isWithSide
      ? {
          0: { items: 1 },
          600: { items: 1 },
          800: { items: 2 },
          1048: { items: itemsCount },
        }
      : {
          0: { items: 1 },
          600: { items: 2 },
          800: { items: 3 },
          1048: { items: itemsCount },
        };

    // Initialize Owl Carousel with optimized settings
    $carousel.owlCarousel({
      loop: true,
      margin: 10,
      nav: false,
      dots: false,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplayHoverPause: true,
      smartSpeed: 500,
      slideBy: 1,
      autoHeight: false,       // disable autoHeight to prevent layout jumps
      animateOut: false,       // disable CSS fadeOut that causes flicker
      animateIn: false,        // disable CSS fadeIn that causes flicker
      responsiveBaseElement: window,
      responsive: responsiveSettings,
    });

    // Scoped nav buttons
    const prevBtn = sectionEl.querySelector('.owl-prev-custom, .owl-prev-custom-side');
    const nextBtn = sectionEl.querySelector('.owl-next-custom, .owl-next-custom-side');

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        $carousel.trigger('prev.owl.carousel');
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        $carousel.trigger('next.owl.carousel');
      });
    }
  });
});